import type { TvWishWallTheme, TvWishWallVisualStyle, WishItem } from "../models/contracts";
import { normalizeWishWallTheme } from "./wishWallThemes";
import { FloatingWishRenderer } from "./renderers/FloatingWishRenderer";
import { GridWishRenderer } from "./renderers/GridWishRenderer";
import { MinimalWishRenderer } from "./renderers/MinimalWishRenderer";
import { MosaicWishRenderer } from "./renderers/MosaicWishRenderer";
import { PolaroidWishRenderer } from "./renderers/PolaroidWishRenderer";
import { SpotlightWishRenderer } from "./renderers/SpotlightWishRenderer";

interface Props { wishes: WishItem[]; theme?: TvWishWallTheme; visualStyle?: TvWishWallVisualStyle; focusId: string | null; arrivalId: string | null; eventTitle: string }

export function TvWishWallRenderer({ wishes, theme, visualStyle = "Elegant", focusId, arrivalId, eventTitle }: Props) {
  const selected = normalizeWishWallTheme(theme);
  const styleClass = `wish-style-${visualStyle.toLowerCase()}`;
  if (!wishes.length) return <div class={`wish-wall-empty wish-theme-${selected.toLowerCase()} ${styleClass}`}><span>✦</span><strong dir="auto">{eventTitle}</strong><p>Wishes will appear here</p></div>;
  const common = { wishes, focusId };
  return <div class={`tv-wish-wall wish-theme-${selected.toLowerCase()} ${styleClass} wish-mood-${visualStyle.toLowerCase()} wish-count-${Math.min(wishes.length, 8)}`} data-wish-theme={selected} data-wish-visual-style={visualStyle} aria-label="TV Wish Wall">
    {selected === "Floating" ? <FloatingWishRenderer {...common} />
      : selected === "Spotlight" ? <SpotlightWishRenderer {...common} arrivalId={arrivalId} />
        : selected === "Grid" ? <GridWishRenderer {...common} />
          : selected === "Mosaic" ? <MosaicWishRenderer {...common} />
            : selected === "Polaroid" ? <PolaroidWishRenderer {...common} />
              : <MinimalWishRenderer {...common} />}
  </div>;
}
